// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64aababc","685":"b7d65f5a","814":"9cc070cc","840":"672664d4"}[chunkId] + ".chunk.js";
};